module.exports = __webpack_public_path__ + "img/phylogeneslogo.9c4b84d8.png";